import { Actions } from 'vuex-smart-module';
import { AxiosResponse } from 'axios';
import { Reports } from '@/modules/reports/types';
import { ReportsService } from '@/modules/reports/services';
import ReportsRepairsGetters from './getters';
import ReportsRepairsMutations from './mutations';
import ReportsRepairsState from './state';

const reportsService = new ReportsService();

export default class ReportsRepairsActions extends Actions<
  ReportsRepairsState,
  ReportsRepairsGetters,
  ReportsRepairsMutations,
  ReportsRepairsActions
> {
  async get_reports_dates() {
    try {
      const { data } = await reportsService.get_reports_dates();

      this.mutations.SET_REPORTS_DATES(data.dates);
    } catch (error) {
      console.log(error);
      return (error as AxiosResponse).status;
    }
  }
  // получение данных о ремонтах за период с сервера

  async get_repairs_reports(payload: Reports.RepairsPayload) {
    try {
      const { data } = await reportsService.get_repairs_reports(payload);

      this.mutations.SET_REPORTS(data.items);
    } catch (error) {
      console.log(error);
      return (error as AxiosResponse).status;
    }
  }
}
